'use strict';

function TwoColumnLayout() {
  $('.paragraph--type--two-columns-layout .two-column-item').matchHeight();

  const left_content = $('.layout-container .content .content_wrapper .region-content-left');

  if (left_content.length > 0 && left_content.text().trim() === '') {
    left_content.closest('.content_wrapper').addClass('no_left_content');
    left_content.remove();
  }

  const right_content = $('.layout-container .content .content_wrapper .region-content-right');

  if (right_content.length > 0 && right_content.text().trim() === '') {
    right_content.closest('.content_wrapper').addClass('no_right_content');
    // right_content.remove();
  }
}

export default TwoColumnLayout;
